var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFF7DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74762 9.08921C9.26345 9.08921 10.4923 7.82944 10.4923 6.2754C10.4923 4.72139 9.26345 3.46161 7.74762 3.46161C6.23177 3.46161 5.00293 4.72139 5.00293 6.2754C5.00293 7.82944 6.23177 9.08921 7.74762 9.08921Z",
    fill: "#007969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5879 10.2141V15.7763L11.9778 15.7621C15.3021 15.6366 16.9927 13.8981 16.9996 10.5997V10.2141H11.5879Z",
    fill: "#F69E89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4911 10.2141H5V15.7568H10.4911V10.2141Z",
    fill: "#7B60A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5879 3V9.08568H16.9996L11.5879 3Z",
    fill: "#FBB116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e7bacf17ccdd3bfeacf9d8fb091f9f90.svg";
export { ForwardRef as ReactComponent };